import type { Template } from "@/types";

export const LA_04_H0_V4: Template[] = [
    {
        id: "la-04-h0v4-01",
        name: "LA 01 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h0_v4_01.png",
        size: [1352, 483],
        style: {},
        slots: [    
            { id: "1", x: 64, y: 81, width: 266, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 338, y: 81, width: 266, height: 373, rotation: 0, imageRotation: 0 },
            { id: "3", x: 612, y: 81, width: 265, height: 373, rotation: 0, imageRotation: 0 },
            { id: "4", x: 948, y: 28, width: 334, height: 427, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-02",
        name: "LA 02 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h0_v4_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 101, y: 40, width: 282, height: 403, rotation: 0, imageRotation: 0 },
            { id: "2", x: 391, y: 40, width: 282, height: 403, rotation: 0, imageRotation: 0 },
            { id: "3", x: 681, y: 40, width: 282, height: 403, rotation: 0, imageRotation: 0 },
            { id: "4", x: 971, y: 40, width: 281, height: 403, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-03",
        name: "LA 03 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h0_v4_03.png",
        size: [1352, 483],
        style: {},
        slots: [         
            { id: "1", x: 57, y: 48, width: 277, height: 386, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 48, width: 277, height: 386, rotation: 0, imageRotation: 0 },
            { id: "3", x: 733, y: 48, width: 277, height: 386, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 48, width: 277, height: 386, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-04-h0v4-04",
        name: "LA 04 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h0_v4_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 377, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 475, y: 65, width: 255, height: 355, rotation: 0, imageRotation: 0 },
            { id: "3", x: 738, y: 65, width: 255, height: 355, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1001, y: 65, width: 255, height: 355, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-05",
        name: "LA 05 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h0_v4_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 106, y: 38, width: 288, height: 408, rotation: 0, imageRotation: 0 },    
            { id: "2", x: 401, y: 38, width: 157, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 401, y: 246, width: 157, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 868, y: 38, width: 291, height: 408, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-06",
        name: "LA 06 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h0_v4_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 43, y: 34, width: 289, height: 415, rotation: 0, imageRotation: 0 },
            { id: "2", x: 541, y: 169, width: 199, height: 280, rotation: 0, imageRotation: 0 },
            { id: "3", x: 748, y: 169, width: 198, height: 280, rotation: 0, imageRotation: 0 },
            { id: "4", x: 954, y: 169, width: 198, height: 280, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-07",
        name: "LA 07 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h0_v4_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 106, y: 38, width: 288, height: 408, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 401, y: 38, width: 157, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 401, y: 246, width: 157, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 868, y: 38, width: 291, height: 408, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-08",
        name: "LA 08 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h0_v4_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 204, y: 52, width: 269, height: 380, rotation: 0, imageRotation: 0 },
            { id: "2", x: 795, y: 51, width: 272, height: 380, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1074, y: 51, width: 146, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1074, y: 245, width: 146, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-09",
        name: "LA 09 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h0_v4_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 119, y: 34, width: 289, height: 415, rotation: 0, imageRotation: 0 },
            { id: "2", x: 434, y: 80, width: 229, height: 322, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 80, width: 227, height: 322, rotation: 0, imageRotation: 0 },
            { id: "4", x: 945, y: 34, width: 289, height: 415, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-10",
        name: "LA 10 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h0_v4_10.png",
        size: [1352, 483],
        style: {},
        slots: [         
            { id: "1", x: 202, y: 102, width: 199, height: 280, rotation: 0, imageRotation: 0 },
            { id: "2", x: 409, y: 102, width: 198, height: 280, rotation: 0, imageRotation: 0 },
            { id: "3", x: 615, y: 102, width: 198, height: 280, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1020, y: 34, width: 289, height: 415, rotation: 0, imageRotation: 0 },
        ],
    }
];

   



